import React, { Component } from 'react';
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import { Typography, Divider } from '@material-ui/core';
import Card from "components/Card/Card.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Article from './common/Article';
import Carousel from "react-slick";
import { formatNumber } from './common/utilities';

// styles
import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.jsx";
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx"
import carouselStyle from "assets/jss/material-kit-pro-react/views/componentsSections/carouselStyle.jsx";

// other assets
import { cardTitle } from "assets/jss/material-kit-pro-react.jsx";

const styles = () => ({
    ...imagesStyles,
    ...cardStyles,
    ...carouselStyle,
    cardTitle,
    articleTitle: { lineHeight: '1.2em' },
    topGrid: {
        display: 'inline-grid',
        position: 'relative',
        overflowX: 'auto',
        left: '-20px'

    },
    topGridCarousel: {
        display: 'inline-grid',
        position: 'relative',
        overflowX: 'auto',
        left: '-20px',
        width: '100%',
        padding: "0 !important"
    },
    topCardGrid: {
        flexWrap: 'nowrap',
        justifyContent: 'flex-start',
        margin: '0'
    },
    cardGrid: {},
    customMedia: {
        width: '100%',
        marginTop: '10px',
        "@media screen and (max-width: 960px)": {
            display: "none"
        }
    },
    customContainer: {maxWidth: "calc(100vw * 0.79) !important"},
    smallContainer: {}
})

class GrantFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        const { classes } = this.props;

        const rotatingCards = document.getElementsByClassName(classes.cardRotate);
        for (let i = 0; i < rotatingCards.length; i++) {
            const rotatingCard = rotatingCards[i],
                cardWidth = rotatingCard.parentElement.offsetWidth,
                cardHeight = rotatingCard.children[0].children[0].offsetHeight;

            let rotatingWrapper = rotatingCard.parentElement,
                cardFront = rotatingCard.getElementsByClassName(classes.front)[0],
                cardBack = rotatingCard.getElementsByClassName(classes.back)[0];

            rotatingWrapper.style.height = cardHeight + "px";
            rotatingWrapper.style["margin-bottom"] = 30 + "px";
            cardFront.style.height = cardHeight + 35 + "px";
            cardFront.style.width = cardWidth + "px";
            cardBack.style.height = cardHeight + 35 + "px";
            cardBack.style.width = cardWidth + "px";
        }
    }

    renderItem(record, subjects, small=false) {
        if (small) {
            return (
                <div className="small-grants-container">
                    <Article 
                        key={record.data_id} 
                        isGrant={true} 
                        record={record}
                        subjects={subjects}
                        utcStart={this.props.utcStart}
                    />
                </div>
            )
        }
        return (
            <Article 
                key={record.data_id} 
                isGrant={true} 
                record={record}
                subjects={subjects}
                utcStart={this.props.utcStart}
            />
        )
    }

    render() {
        const { classes } = this.props;
        const { totalRecords, queryTerm, isFetching, records, subjectFilters } = this.props.data;
        const settings = {
            dots: false,
            infinite: true,
            speed: 1000,
            autoplay: false,
            draggable: true
        };

        return (
            isFetching || (records && !records.length) ?
                null
                : <div className={`top-banner-container ${classes.customMedia}`}>
                    <Typography variant="title" gutterBottom>
                        Showing {totalRecords ? formatNumber('' + totalRecords) : ''} <b>grants</b>
                        {queryTerm.length ? ` for ${queryTerm.replace(/\\"/g, '"')}` : ''}
                    </Typography>
                    <Divider />
                    <div className={`${classes.section} ${classes.topGridCarousel}`} id="carousel">
                        <div className={`${classes.container} ${classes.customContainer}`}>
                            <GridContainer>
                                <GridItem className={classes.marginAuto}>
                                    <Card>
                                        {
                                            records ?
                                                <Carousel {...settings} 
                                                    slidesToShow={records.length < 3 ? records.length : 3} 
                                                    slidesToScroll={records.length < 3 ? 1 : 3}>
                                                    {
                                                        records ? 
                                                            records.map((record, index) => this.renderItem(record, subjectFilters, records.length < 3)) 
                                                            : undefined
                                                    }
                                                </Carousel>
                                                : undefined
                                        }
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </div>
                    </div>
                </div>
        )
    }
}

GrantFeed.propTypes = {
    classes: PropTypes.object,
    data: PropTypes.object,
    totalRecords: PropTypes.number,
    queryTerm: PropTypes.string,
    isFetching: PropTypes.bool,
    records: PropTypes.array,
    yesNoClick: PropTypes.func,
    utcStart: PropTypes.instanceOf(Date)
}


// export default NewsFeed;
export default withStyles(styles)(GrantFeed);


// WEBPACK FOOTER //
// ./src/components/Article/BannerFeed.jsx